import * as React from 'react';
import SuperCritical from 'lib/supercritical';
import { VesselStatus, VesselStatusDisplayName } from 'server/enums/VesselStatus';

export const SiteAdminSettingsView = SuperCritical(() =>
    <div className="siteadminsettings pc-page-fixedwidth">
        <div className="pc-actions-links-header">
            <a className="pc-back-link" href="#!morepage">&lt;&lt; Back to More</a>
        </div>
        <h1 className="pc-page-title">
            <span className="pc-text-label-color">More</span><span className="pc-icon-bullet"></span>
            <span>Site Admin Settings</span>
        </h1>
        <div className="page-body pc-card">
            <div className="setting-shell">
                <div className="setting-link">
                    <a href="#!berthlookups">Berth Lookups</a>
                </div>
                <div className="setting-description pc-text-smalllabel">
                    Add, edit, and rearrange the order of port names and capabilities.
                </div>
            </div>
            <div className="setting-shell">
                <div className="setting-link">
                    <a href="#!manageberths">Manage Berths</a>
                </div>
                <div className="setting-description pc-text-smalllabel">
                    Add, remove, rearrange, link, and view all of the berths in the system.
                </div>
            </div>
            <div className="setting-shell">
                <div className="setting-link">
                    <a href={`#!pendingvesselservicelisting?status=${VesselStatusDisplayName[VesselStatus.Pending]}`}>Manage Pending Vessels</a>
                </div>
                <div className="setting-description pc-text-smalllabel">
                    Link Pending Vessels to Service Vessels
                </div>
            </div>
        </div>
    </div>
);



// WEBPACK FOOTER //
// ./apps/portcall/siteadminsettings/view.tsx